<script setup></script>

<template>
  <VBusHelper :emitOnMounted="$constants.EVENTS.AFFILIATION.LIST_ALL.REFRESH" />
  <!-- <div class="py-4"></div> -->
  <TransactionsLoadingErrorAffiliation
    @refresh="() => $bus.emit($constants.EVENTS.AFFILIATION.LIST_ALL.REFRESH)"
    v-if="$stores.affiliation?.state?.list_all?.error"
  >
    <template #errorDescription>
      {{ $stores.affiliation?.state?.list_all?.error }}
    </template>
  </TransactionsLoadingErrorAffiliation>
  <div
    v-else-if="$stores.affiliation?.state?.list_all?.list.length"
    class="space-y-4 divide-y divide-[#DCD2F8] px-6"
  >
    <TransactionItemAffiliation
      v-for="trx in $stores.affiliation?.state?.list_all?.list"
      :item="trx"
    />
  </div>
  <div
    v-else-if="$stores.affiliation?.state?.list_all?.loading"
    class="space-y-4 divide-y divide-transparent px-6 shimmerContainer"
  >
    <TransactionItemAffiliation v-for="trx in 3" :item="trx" />
  </div>
  <EmptyTransactionsAffiliation
    @refresh="() => $bus.emit($constants.EVENTS.AFFILIATION.LIST_ALL.REFRESH)"
    v-else
  />
</template>
